import React from "react";
import { Web3ReactProvider } from "@web3-react/core";
const { Web3Provider } = require("@ethersproject/providers");

const Web3 = ({ children }: any) => {
    function getLibrary(provider: any) {
        const library = new Web3Provider(provider);
        library.pollingInterval = 8000;
        return library;
    }
    return (
        <Web3ReactProvider getLibrary={getLibrary}>{children}</Web3ReactProvider>
    );
};

export default Web3;
